(function(window, overwatch){

    var MediaLightbox = {
		init: function(options) {
			this.bindScreenshots();
			this.bindArtwork();
			this.bindVideos();
		},

		bindScreenshots: function() {
			var self = this;

			$(".web .screenshots-list a").bind('click', function(event) {
				var curElem = $(this);
				var images = self.getSectionList("screenshots");
				var index = self.indexOf(images, curElem, 0);
				Lightbox.loadImage(images, index);
				event.preventDefault();
			});
		},

		bindArtwork: function() {
			var self = this;

			$(".web .artwork-list a").bind('click', function(event) {
				var curElem = $(this);
				var images = self.getSectionList("artwork");
				var index = self.indexOf(images, curElem, 0);
				Lightbox.loadImage(images, index);
				event.preventDefault();
			});
		},

		bindVideos: function() {
			var self = this;

			$(".web .videos-list a").bind('click', function(event) {
				var curElem = $(this);
				var videos = self.getSectionList("videos");
				var index = self.indexOf(videos, curElem, 0);
				Lightbox.loadEmbed(videos, index);
				event.preventDefault();
			});

		},

		getSectionList: function(sectionName) {
			var elemList = [];
			$("." + sectionName + "-list li").each(function(curIndex) {
				elemList.push($(this).data());
			});

			return elemList;
		},

		/**
		 * Returns the index of a particular Element in the data object haystack.
		 * Will return -1 if not found.
		 */
		indexOf: function(haystack, sourceObj, notFound) {
			if (typeof notFound == 'undefined') {
				notFound = -1;
			}
			var needle = $(sourceObj);
			for(var i = 0; i < haystack.length; i++) {
				if (needle.data("key") === haystack[i].key) {
					return i;
				}
			}
			return notFound;
		}
	};

    window.MediaLightbox = MediaLightbox;

}(window, window.overwatch));
